// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"853":"5a074b93","5465":"d229b3e8","5529":"3ba07506","9127":"6cdbfeee"}[chunkId] + ".chunk.css";
};